import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import searchIcon from "../assets/images/search_icon.svg";
import addIcon from "../assets/images/add-icon.svg";
import editIcon from "../assets/images/edit_icon.svg";
import { toast } from "react-toastify";
import "../styles/dataTable.css";
import "../styles/manageCategory.css";

const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL.endsWith("/")
  ? process.env.REACT_APP_IMAGE_BASE_URL
  : process.env.REACT_APP_IMAGE_BASE_URL + "/";

const Blog = () => {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState("");

  /* ---------------- FETCH BLOGS ---------------- */

  const fetchBlogs = async () => {
    try {
      const res = await api.get("/Blog/get-all");

      if (res.data.status === "success") {
        setBlogs(res.data.data || []);
      }
    } catch {
      toast.error("Failed to load blogs");
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const filteredBlogs = blogs.filter((b) =>
    b.blogname?.toLowerCase().includes(search.toLowerCase())
  );

  /* ---------------- UI ---------------- */

  return (
    <div>
      <div style={{ padding: "20px" }}>

        <div className="table-header">

          <h2 style={{ fontWeight: 700 }}>
            Blog
          </h2>

          <div className="search-container">
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <img
              src={searchIcon}
              alt="search"
            />
          </div>

          <div className="action-btn">
            <button
              onClick={() => navigate("/blog/create")}
            >
              <img
                src={addIcon}
                alt="add"
              />

              Add Blog
            </button>
          </div>

        </div>

        <table
          width="100%"
          cellPadding="26"
          className="table-no-outer-border"
        >

          <thead>
            <tr>

              <th>
                Image
              </th>

              <th style={{ textAlign: "center" }}>
                Title
              </th>

              <th>
                Action
              </th>

            </tr>
          </thead>

          <tbody>

            {filteredBlogs.length ? (

              filteredBlogs.map((row) => (

                <tr key={row.id}>

                  <td>

                    {row.blogshortimg ? (

                      <img
                        src={`${IMAGE_BASE_URL}${row.blogshortimg}`}
                        alt="blog"
                        style={{
                          maxWidth: 100
                        }}
                      />

                    ) : (
                      "—"
                    )}

                  </td>

                  <td
                    style={{
                      textAlign: "center"
                    }}
                  >
                    {row.blogname}
                  </td>

                  <td>

                    <div className="buttons-actions">

                      <button
                        className="edit-button"
                        onClick={() =>
                          navigate(`/blog/edit/${row.id}`)
                        }
                      >

                        <img
                          src={editIcon}
                          alt="edit"
                        />

                        Edit

                      </button>

                    </div>

                  </td>

                </tr>

              ))

            ) : (

              <tr>

                <td
                  colSpan={4}
                  align="center"
                >
                  No Data
                </td>

              </tr>

            )}

          </tbody>

        </table>

      </div>
    </div>
  );
};

export default Blog;